/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';
import { LegacyBuyButton } from '../../Buttons/LegacyBuyButton/LegacyBuyButton';
import ProductFlashTag from '../FlashTag/ProductFlashTag';
import ImageHostMom from '../../../utility/ImageHosts/ImageHostMom';
import { formatAbv, formatVolume } from '../../../utility/strings';
import { setBuyButtonsInBasketStatus, getFullProductFromProductsInBasket } from '../../utils/basket';
import { StyledByoButton, StyledAttributes, StyledDescription, StyledInfoContainer, StyledPriceContainer, StyledProductContent, StyledProductContentInner, StyledProductImage, StyledProductPurchaseInfo, StyledProductTile, StyledProductTileInner, StyledTryASample } from './HorizontalProductCard.styled';
import DramIcon from '../../assets/DramIcon';
import { StyledSponsoredFlag } from '../SharedProductElements/shared.styled';
import { Reviews } from '../SharedProductElements/shared';
import useViewportEvents from '../../../hooks/useViewportEvents';
import Discount from '../Discount/Discount';
import { discountTypeToDiscountFlag } from '../../utils/products';
const abvAndVolume = _ref => {
  let {
    volume,
    abv
  } = _ref;
  if (!volume && !abv) {
    return null;
  }
  let innerText = '';
  if (volume) {
    const resolvedAbv = abv || 0;
    innerText = `${formatVolume(volume)}cl / ${formatAbv(resolvedAbv)}%`;
  }
  return /*#__PURE__*/React.createElement(StyledAttributes, {
    className: "product-list-tile-attributes"
  }, innerText);
};
export const HorizontalProductCard = _ref2 => {
  let {
    product,
    displayExVatPrices,
    viewportEvents,
    suppressOnAddProductClickEvent = false,
    byoTypeId,
    byoAddClass,
    byoRebindMethod,
    onAddToBasket,
    clickTrackCallback,
    analyticsContext,
    minimumTotalReviews = 5,
    renderBuyButton,
    LinkComponent = 'a',
    renderPrice = p => /*#__PURE__*/React.createElement(React.Fragment, null, p)
  } = _ref2;
  const {
    id,
    urlRelative,
    imageUrlRelative,
    name,
    shortName,
    description,
    meta,
    reviews,
    buyStatus,
    price,
    availability
  } = product;
  const [ref] = useViewportEvents(viewportEvents);
  useEffect(() => {
    if (typeof byoRebindMethod === 'function') {
      byoRebindMethod();
    }
  });
  let byoButton;
  const showByoButton = !!(buyStatus !== 'DISCONTINUED' && byoTypeId && byoAddClass);
  if (showByoButton) {
    // The wrapping div below is required. The BYO button disappears when used on the Website without
    // it, however, it looks fine in Storybook. This only started occurring once the "Try a sample" block
    // was added. I suspect it's something to do with the BYO code in the Website modifying the button.
    byoButton = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledByoButton, {
      id: `${id}_addToBYOButton`
      // eslint-disable-next-line max-len
      ,
      className: `mom-btn mom-btn-buy ${byoAddClass}`,
      rel: "nofollow",
      href: "#addBYO",
      "data-byo-type": byoTypeId
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "mom-btn-buy-basket-quantity"
    }), /*#__PURE__*/React.createElement("div", {
      className: "mom-btn-text"
    }))));
  }
  const handleClickLink = event => {
    if (clickTrackCallback) {
      clickTrackCallback(event);
    }
  };
  const showReviews = (reviews.rating ?? 0) > 0 && reviews.count > minimumTotalReviews;

  // Not great we have to undo the transformation on this to use the Discount component
  const discountFlag = discountTypeToDiscountFlag(product.price.discountType);
  return /*#__PURE__*/React.createElement(StyledProductTile, {
    ref: ref
  }, /*#__PURE__*/React.createElement(ProductFlashTag, {
    product: product
  }), meta.sponsored && /*#__PURE__*/React.createElement(StyledSponsoredFlag, null, "Sponsored"), /*#__PURE__*/React.createElement(StyledProductTileInner, null, /*#__PURE__*/React.createElement(StyledProductContent, {
    href: urlRelative,
    onClick: handleClickLink,
    as: LinkComponent
  }, /*#__PURE__*/React.createElement(StyledProductImage, {
    src: imageUrlRelative,
    alt: `${shortName} product image`,
    width: 96,
    height: 104,
    quality: 70,
    scaling: 2.5,
    imageHost: new ImageHostMom(),
    contain: true,
    backgroundColor: "fff"
  }), /*#__PURE__*/React.createElement(StyledProductContentInner, null, /*#__PURE__*/React.createElement("h3", {
    className: "product-list-tile-title"
  }, name), /*#__PURE__*/React.createElement(StyledInfoContainer, null, abvAndVolume(meta), showReviews ? /*#__PURE__*/React.createElement(Reviews, {
    reviews: reviews,
    justifyContent: "flex-start"
  }) : null), /*#__PURE__*/React.createElement(StyledDescription, null, description.length > 300 ? description.slice(0, 300) : description))), /*#__PURE__*/React.createElement(StyledProductPurchaseInfo, null, buyStatus !== 'DISCONTINUED' && /*#__PURE__*/React.createElement(StyledPriceContainer, null, price.current ? /*#__PURE__*/React.createElement(Discount, {
    className: "priceText",
    discountClassName: "discountText",
    displayExVatPrices: displayExVatPrices,
    price: price.current,
    renderPrice: renderPrice,
    hasBespokePrice: product.meta.hasBespokePrice,
    previousPrice: price.discountType === 'PREVIOUS_PRICE' || price.discountType === 'LIGHTNING_DEAL' ? price.discountedFrom : undefined,
    rrp: price.discountType === 'PRICE_DROP' ? price.discountedFrom : undefined,
    discountFlag: discountFlag
  }) : /*#__PURE__*/React.createElement("div", {
    style: {
      lineHeight: '35px'
    }
  }, "\xA0")), product.meta.showBuyButton && typeof renderBuyButton === 'function' && renderBuyButton(product), product.meta.showBuyButton && typeof renderBuyButton !== 'function' && /*#__PURE__*/React.createElement(LegacyBuyButton, {
    productId: id,
    unlimitedStock: availability.unlimitedStock,
    stockIsIncoming: buyStatus === 'STOCK_INCOMING',
    isAvailable: ['IN_STOCK', 'PRE_ORDER'].includes(buyStatus) ? 1 : 0,
    discontinued: buyStatus === 'DISCONTINUED',
    isComingSoon: buyStatus === 'COMING_SOON',
    preOrder: buyStatus === 'PRE_ORDER',
    maxNumberPerCustomer: availability.maxNumberPerCustomer,
    freeStock: availability.freeStock,
    setBuyButtonsInBasketStatus: setBuyButtonsInBasketStatus,
    getFullProductFromProductsInBasket: getFullProductFromProductsInBasket,
    key: `buy-button-${id}`,
    addToBasket: () => {
      if (product.meta.sponsored && product.meta.sponsoredClickUrl) {
        window.PubSub.publish('Sponsored.Click', {
          url: product.meta.sponsoredClickUrl,
          callback: () => {}
        });
      }
      if (typeof onAddToBasket === 'function') {
        onAddToBasket();
      }
      return new Promise(resolve => {
        if (!(window && window.AddToBasket)) {
          console.warn('AddToBasket not available');
          return;
        }
        const payload = {
          suppressClickEvent: suppressOnAddProductClickEvent
        };
        if (analyticsContext) {
          payload.listName = analyticsContext.productListName;
          payload.position = analyticsContext.position;
        }
        window.AddToBasket(id, buyStatus === 'PRE_ORDER', response => resolve(response), payload);
      });
    }
  }), showByoButton && byoButton, product.meta.hasDram && !showByoButton && /*#__PURE__*/React.createElement(StyledTryASample, {
    href: urlRelative,
    as: LinkComponent
  }, /*#__PURE__*/React.createElement(DramIcon, null), "Try a sample"))));
};
export default HorizontalProductCard;